"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconTShirtActive = Experimental__IconTShirtActive;
exports.IconTShirtActive = IconTShirtActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconTShirtActive/index.tsx)
 */
function IconTShirtActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4.75 1c-.307 0-.614.094-.875.282L.625 3.615A1.5 1.5 0 0 0 .152 5.49l1.3 2.666A1.5 1.5 0 0 0 3 8.987V13.5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5V8.987a1.499 1.499 0 0 0 1.548-.83l1.3-2.666a1.5 1.5 0 0 0-.473-1.876l-3.25-2.333a1.498 1.498 0 0 0-1.645-.07c-.942.564-2.13 1.098-2.491 1.122-.341-.024-1.529-.558-2.468-1.12-.233-.14-.5-.214-.771-.214Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M19 13.033V21a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7.967l-.642.117a2 2 0 0 1-2.176-1.135l-2-4.364A2 2 0 0 1 .786 5.23l5-3.819a2 2 0 0 1 2.288-.097l.005.003.023.014a26.826 26.826 0 0 0 1.727.985c.49.254.99.488 1.431.655.22.082.403.14.548.175.117.029.178.035.192.036.014 0 .075-.007.192-.036.145-.035.328-.093.548-.175.441-.167.941-.401 1.43-.655a25.893 25.893 0 0 0 1.728-.985l.023-.014.005-.003a2 2 0 0 1 2.288.097l5 3.819a2 2 0 0 1 .604 2.423l-2 4.363a2 2 0 0 1-2.176 1.135L19 13.033Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTShirtActive is deprecated and will be archived soon. Use IconTShirtActive instead.
 */
function Experimental__IconTShirtActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconTShirtActive, props);
}